<template>
  <b-modal 
    :id="modalId"
    :title="$t('engine.sidebar.widget.tab.manage.lblAddTabItem', languageEngine)"
    no-close-on-esc
    no-close-on-backdrop
    @hidden="close"
  >
    <FormGroup :class="{ errors: $v.tabName.$error }" :label="$t('engine.sidebar.widget.tab.manage.lblTabName', languageEngine)">
      <b-form-input v-model.trim="$v.tabName.$model"/>
      <small class="text-danger" v-if="!$v.tabName.required && $v.tabName.$dirty">
        {{ $t('engine.sidebar.widget.tab.manage.msgTabName', languageEngine) }}
      </small>
    </FormGroup>

    <template #modal-footer>
      <b-button variant="blue" class="mr-2" @click.stop.prevent="addTabItem">
        <i class="far fa-check"></i> {{ $t('engine.sidebar.widget.tab.manage.btnAddTab', languageEngine) }}
      </b-button>
      <b-button variant="secondary" @click="cancel">
        <i class="far fa-times"></i> {{ $t('engine.common.btnCancel', languageEngine) }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { WIDGET } from "@model/components/componentMeta.model"
import { mock2Component } from "@helpers/component.helper";
import { required } from "vuelidate/lib/validators";
import presetService from "@services/presetService.js";
import FormGroup from "@components_system/Shared/Tools/FormGroup/FormGroup";

export default {
  components: {
    FormGroup,
  },
  computed: {
    ...mapGetters({
      modal: "design/modal",
      modalPayload: "design/modalPayload",
      metaDataID: "design/metadata/metaDataID",
      languageEngine: "design/userPreference/languageEngine",
      presetsWidget: "design/component/presetsWidget",
      elActiveID: "design/component/elActiveID",
      components: "design/metadata/components",
    }),
    tabId() {
      return this.elActiveID[1];
    },
    tab() {
      return this.components[this.tabId];
    }
  },
  data() {
    return {
      modalId: "modal-add-tab-item",
      tabName: "",
    };
  },
  methods: {
    addTabItem() {
      if (this.presetsWidget.tab_item) {
        this.$v.$touch();
        if (this.$v.$invalid) return;

        const id = this.presetsWidget.tab_item.selectLayout[0].id;
        const obj = { id, metaName: WIDGET.name, languageUse: this.languageUse, metaDataID: this.metaDataID };
        presetService.getPresetRender(obj).then((response) => {
          const { key, object } = mock2Component(this.components, response);
          object[key].data = this.tabName.trim();

          this.$store.dispatch("designIframe/component/addNewComponent", { 
            key, 
            object, 
            parentID: this.tabId
          });

          setTimeout(() => {
            this.$store.dispatch("designIframe/frame/setWidgetTabActive", {
              component_id: this.tabId,
              index: this.tab.componentsID.length - 1,
            });
          }, 100);

          this.close();
        });
      }
    },
    cancel() {
      this.close();
    },
    close() {
      this.$bvModal.hide(this.modalId);
      this.$store.dispatch("design/setModal", { name: "" });
    },
  },
  watch: {
    modal: {
      async handler() {
        if (this.modal == this.modalId) {
          this.tabName = "";
          this.$v.$reset();

          this.$bvModal.show(this.modalId);
          if (!this.presetsWidget.tab_item) {
            await this.$store.dispatch("design/component/loadPreset", {
              type: 'tab_item',
              metaName: 'widget',
            });
          }
        }
      },
    },
  },
  validations: {
    tabName: { required },
  },
};
</script>